(function () {
  function normalizeVideoId(value, platform) {
    if (!value) return '';

    const input = String(value).trim();
    if (!/^https?:\/\//i.test(input)) return input;

    try {
      const url = new URL(input);

      if (platform === 'youtube') {
        if (url.hostname.includes('youtu.be')) return url.pathname.replace(/^\//, '');
        const v = url.searchParams.get('v');
        if (v) return v;
        const parts = url.pathname.split('/').filter(Boolean);
        const embedIndex = parts.indexOf('embed');
        if (embedIndex !== -1 && parts[embedIndex + 1]) return parts[embedIndex + 1];
        const shortsIndex = parts.indexOf('shorts');
        if (shortsIndex !== -1 && parts[shortsIndex + 1]) return parts[shortsIndex + 1];
      }

      if (platform === 'vimeo') {
        const parts = url.pathname.split('/').filter(Boolean);
        return parts[parts.length - 1] || '';
      }
    } catch (e) {
      return input;
    }

    return input;
  }

  function getVideoSrc(platform, videoId, mobileVideoId) {
    const isMobile = window.innerWidth < 1024;
    const selectedId = isMobile && mobileVideoId ? mobileVideoId : videoId;
    const normalizedId = normalizeVideoId(selectedId, platform);

    if (!normalizedId) return '';

    if (platform === 'youtube') {
      return 'https://www.youtube.com/embed/' + normalizedId + '?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1';
    }

    if (platform === 'vimeo') {
      return 'https://player.vimeo.com/video/' + normalizedId + '?autoplay=1&controls=1&title=0&byline=0&portrait=0';
    }

    return '';
  }

  function openLightbox(lightbox) {
    if (!lightbox) return;
    lightbox.hidden = false;
    lightbox.classList.remove('hidden');
    lightbox.setAttribute('aria-hidden', 'false');
  }

  function closeLightbox(lightbox) {
    if (!lightbox) return;
    const embedContainer = lightbox.querySelector('[id^="embed-video-"]');
    if (embedContainer) embedContainer.innerHTML = '';
    lightbox.hidden = true;
    lightbox.classList.add('hidden');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (event) {
    const playBtn = event.target.closest('[id^="playbtn-cms-"]');
    if (playBtn) {
      event.preventDefault();
      event.stopPropagation();

      const videoBlock = playBtn.closest('[id^="data-video-"]');
      if (!videoBlock) return;

      const lightbox = videoBlock.querySelector('[id^="video-lightbox-"]');
      const embedContainer = videoBlock.querySelector('[id^="embed-video-"]');
      if (!lightbox || !embedContainer) return;

      const platform = (embedContainer.getAttribute('data-type') || '').trim();
      const videoId = (embedContainer.getAttribute('data-id') || '').trim();
      const mobileVideoId = (embedContainer.getAttribute('data-id-mobile') || '').trim();
      const videoSrc = getVideoSrc(platform, videoId, mobileVideoId);

      if (!videoSrc) {
        console.warn('Video source could not be built', { platform: platform, videoId: videoId, mobileVideoId: mobileVideoId });
        return;
      }

      embedContainer.innerHTML = '<iframe src="' + videoSrc + '" class="w-full h-full" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen title="Embedded video"></iframe>';
      openLightbox(lightbox);
      return;
    }

    const closeBtn = event.target.closest('.close');
    if (closeBtn) {
      const lightbox = closeBtn.closest('[id^="video-lightbox-"]');
      closeLightbox(lightbox);
      return;
    }

    const lightboxBg = event.target.closest('[id^="video-lightbox-"]');
    if (lightboxBg && event.target === lightboxBg) {
      closeLightbox(lightboxBg);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const activeLightbox = document.querySelector('[id^="video-lightbox-"]:not(.hidden)');
      if (activeLightbox) closeLightbox(activeLightbox);
    }
  });
})();
